
<template>
  <div :class="['modal-confirm', isActive ? 'is-active' : '']">
    <div class="modal-background" @click="closeModal"></div>
    <div :class="['modal-content', size === 'small' ? 'is-small' : size === 'xsmall' ? 'is-xsmall' : 'is-large']">
      <div class="box">
        <h3>{{ title }}</h3>
        <p class="py-4">{{ message }}</p>
        <div class="buttons d-flex justify-content-between">
          <button type="button" class="btn btn-gray my-0 mr-3" @click="cancel">Avbryt</button>
          <button type="button" class="btn btn-light my-0" @click="confirm"> {{ buttonText }}</button>
        </div>
      </div>
    </div>
    <button class="modal-close is-large" aria-label="close" @click="closeModal">
      X
    </button>
  </div>
  
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "Modal",
  props: {
    title: {
      type: String,
      default: "Confirmation",
    },
    message: {
      type: String,
      default: "Are you sure you want to do this?",
    },
    buttonText: {
      type: String,
      default: "Confirm",
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    size: {
      type: String as PropType<"small" | "large" | "xsmall">,
      default: "large",
    },
  },
  emits: {
    confirm: () => true,
    cancel: () => true,
  },
  setup(props, { emit }) {

    const confirm = function () {
      emit("confirm");
    };

    const cancel = function () {
      emit("cancel");
    };

    const closeModal = () => {
      emit("update:isActive", false);
    };

    return {
      confirm,
      cancel,
      closeModal,
    };
  },
});
</script>

<style scoped lang="scss">
@media only screen and (max-width: 480px) {
  .buttons {
    display: block;
  }
}

.modal-confirm {
  align-items: center;
  display: none;
  justify-content: center;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  z-index: 20;

  &.is-active {
    display: flex;
  }

  .modal-background {
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: -1;
  }

  .modal-content {
    background-color: white;
    border-radius: 5px;
    max-height: 90vh;
    max-width: 90vw;
    overflow-y: auto;
    position: relative;
    padding: 20px;

    @media only screen and (min-width: 992px) {
      &.is-small {
        max-width: 50vw;
      }
      &.is-xsmall {
        max-width: 30vw;
      }
    }
  }

  .modal-close {
    background: none;
    border: none;
    color: white;
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
  }
}

@media only screen and (max-width: 480px) {
  .buttons {
    display: block;
  }
  .is-small {
    max-width: 70vw;
  }
  .is-xsmall {
    max-width: 70vw;
  }
}
</style>
